export async function DocumentacionUpdate(
    docTitulo, docData, tratamientoId, pacienteId, documentacionId, docFileUrl
    ) {
    let docFileLink = "";
    if (docFileUrl) {
       docFileLink = docFileUrl;
    }

    const formData = {
        title: `us-${pacienteId}-tr-${tratamientoId}-documentacion-${docTitulo}`,
        slug: `us-${pacienteId}-tr-${tratamientoId}-documentacion-${docTitulo}`,
        status: "publish",
        tratamiento: tratamientoId,
        paciente: pacienteId,
        meta: {
            docTitulo: docTitulo,
            docFileLink: docFileLink,
            docData: docData,
            // docResp: docResp, Añadir para tener control sobre quien crear el doc. Campo automático
            // docFecha: docFecha, Añadir para tener control sobre cuando crear el doc. Campo automático
        }
    };
	const authToken = sessionStorage.getItem( 'token' );
        try {
            const response = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/documentacion/${documentacionId}`, {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}